if (!customElements.get('subscription-select')) {
  customElements.define('subscription-select', class SubscriptionSelect extends ModalDialog {
    constructor() {
      super();

      this.productId = this.dataset.productId;
      this.productSellingPlan = document.getElementById(`selling_plan_${this.productId}`);
      this.productQty = document.getElementById(`qty_${this.productId}`);
      this.form = document.getElementById(`${this.dataset.formId}`);
      this.variantInput = this.form && this.form.querySelector('[name="id"]');
      this.button = this.querySelector('.button[type="button"]');
      this.button.addEventListener('click', this.onSubmitHandler.bind(this));
      this.addEventListener('change', this.onChangeHandler.bind(this));
      
      // Thêm log ở đây
      console.log(`Form ID dataset: ${this.dataset.formId}`);
    }

    onChangeHandler(evt) {
      if (evt.target.tagName === 'INPUT' && evt.target.name === `plan_${this.productId}`) {
        console.log(evt.target);
        this.querySelectorAll(`[name="plan_${this.productId}"]`).forEach((input) => input.removeAttribute('checked'));
        if (evt.target.dataset.available === 'false') {
          this.button.setAttribute('aria-disabled', true);
          this.button.setAttribute('disabled', true);
        } else {
          this.button.removeAttribute('aria-disabled');
          this.button.removeAttribute('disabled');
        }
      }
    }

    async addToCart(formData) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('Added to cart successfully:', result);
        
        // Hiển thị thông báo thành công
        this.showSuccessMessage('Product added to cart successfully!');
        
        // Cập nhật số lượng trong giỏ hàng (nếu có)
        this.updateCartCount();
        
        return result;
      } catch (error) {
        console.error('Error adding to cart:', error);
        this.showErrorMessage('Failed to add product to cart. Please try again.');
        throw error;
      }
    }

    showSuccessMessage(message) {
      window.location.href="https://keanto.com/cart";
    }

    showErrorMessage(message) {

    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        // Cập nhật số lượng sản phẩm trong giỏ hàng
        const cartCountElements = document.querySelectorAll('.cart-count, .cart-item-count');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      const sellingPlan = this.querySelector(`[name="plan_${this.productId}"]:checked`) || this.querySelector(`[name="plan_${this.productId}"][checked]`);

      if (sellingPlan && this.productSellingPlan) {
        const available = sellingPlan.dataset.available;
        if (available === 'false') {
          this.button.setAttribute('aria-disabled', true);
          this.button.setAttribute('disabled', true);
          return;
        } else {
          this.button.removeAttribute('aria-disabled');
          this.button.removeAttribute('disabled');
        }

        // Disable button để tránh click nhiều lần
        this.button.setAttribute('disabled', true);
        this.button.textContent = 'Adding...';

        try {
          const quantityInput = sellingPlan.closest('.plan')?.querySelector('input[name="quantity"]');
          let quantity = 1; // Default quantity
          
          if (quantityInput) {
            quantity = parseInt(quantityInput.value) || 1;
            if (this.productQty) {
              this.productQty.value = quantity;
            }
          }

          const variantId = sellingPlan.dataset.variantId;
          if (variantId && this.variantInput) {
            this.variantInput.value = variantId;
          }

          // Chuẩn bị data để gửi AJAX
          const formData = {
            items: [{
              id: variantId || this.variantInput?.value,
              quantity: quantity
            }]
          };

          // Chỉ thêm selling plan nếu có giá trị và khác "0"
          const sellingPlanValue = sellingPlan.value;
          if (sellingPlanValue && sellingPlanValue !== "0" && sellingPlanValue !== 0) {
            formData.items[0].selling_plan = sellingPlanValue;
            if (this.productSellingPlan) {
              this.productSellingPlan.value = sellingPlanValue;
            }
          } else {
            // Nếu selling_plan là "0" hoặc không có, xóa selling_plan khỏi productSellingPlan
            if (this.productSellingPlan) {
              this.productSellingPlan.value = "";
            }
          }

          console.log('Sending to cart:', formData);

          // Gọi API add to cart
          await this.addToCart(formData);
          
          // Đóng popup sau khi thành công
          this.hide();

        } catch (error) {
          console.error('Error in onSubmitHandler:', error);
        } finally {
          // Restore button state
          this.button.removeAttribute('disabled');
          this.button.textContent = 'Add to cart'; // Hoặc text gốc của button
        }
      }
    }
  });
}